import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { loginBanner2c3004yosmlht as loginBanner } from '../../screens/auth/LogInScreen.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  AuthDialogSemantic_getInstancetw8ua0jubs3m as AuthDialogSemantic_getInstance,
  get_appThemejy2o9bdilpry as get_appTheme,
} from '../../theming/appTheme.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Set2awzlbbrsme5i as Set,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  title1nssp3ryhwuqj as title,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from '../nav/crowpay.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  Action1a4ymn5nx79hk as Action,
} from '../../../utils/utils.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function inviteView(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var tmp = get_centered(writer);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowCollapsingToColumn())(writer.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.lbb(get_centered(view_0), loginBanner(view_0));
  var tmp_0 = view_0.kbb(get_centered(view_0), view_0.jbb(AuthDialogSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  var tmp_1 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_rem(30));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(true);
  Companion_getInstance();
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  var theme = get_appTheme();
  var tmp$ret$0 = new (Set())(theme);
  view_2.lba(tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.lbb(get_centered(view_3), title(view_3, "You're Invited!"));
  var tmp_2 = get_centered(view_3);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp$ret$1 = 'Invited by: ' + $this$reactiveScope.daj(_this__u8e3s4.hgl()).v5i_1;
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view_3.hbb(p_4, view_4);
  view_3.lbb(tmp_2, view_4);
  view_2.hbb(p_3, view_3);
  greySeparator(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_5 = view_2.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
  view_2.gbb(p_5, view_5);
  view_5.zbm(true);
  view_5.bb9(get_rem(0));
  title(view_5, 'Project Preview');
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl_0(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_0(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$12 = $this$reactiveScope.daj(_this__u8e3s4.lfy()).b7b_1;
    this_1.set(tmp$ret$12);
    return Unit_instance;
  });
  view_5.hbb(p_6, view_6);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.gbb(p_7, view_7);
  view_7.lba(view_7.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_1(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_1(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$19 = $this$reactiveScope.daj(_this__u8e3s4.lfy()).c7b_1;
    this_2.set(tmp$ret$19);
    return Unit_instance;
  });
  view_5.hbb(p_7, view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (Space())(view_5.pc());
  var tmp0_elvis_lhs_8 = view_5.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
  view_5.gbb(p_8, view_8);
  view_5.hbb(p_8, view_8);
  bodyBold(view_5, 'Project Address');
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_9 = view_5.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_5 : tmp0_elvis_lhs_9;
  view_5.gbb(p_9, view_9);
  view_9.lba(view_9.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl_2(view_9);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_2(view_9));
  reactiveScope(view_9, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.daj(_this__u8e3s4.lfy()).d7b_1;
    var tmp$ret$31 = it.p55_1 + ', ' + it.r55_1 + ', ' + it.s55_1.toString() + ', ' + it.t55_1;
    this_3.set(tmp$ret$31);
    return Unit_instance;
  });
  view_5.hbb(p_9, view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Space())(view_5.pc());
  var tmp0_elvis_lhs_10 = view_5.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_5 : tmp0_elvis_lhs_10;
  view_5.gbb(p_10, view_10);
  view_5.hbb(p_10, view_10);
  bodyBold(view_5, 'Client');
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_11 = view_5.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_5 : tmp0_elvis_lhs_11;
  view_5.gbb(p_11, view_11);
  view_11.lba(view_11.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_11 = KMutableProperty0();
  var tmp_12 = TextView$_get_content_$ref_4pzcwl_3(view_11);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb_3(view_11));
  reactiveScope(view_11, ($this$reactiveScope) => {
    var tmp$ret$41 = $this$reactiveScope.daj(_this__u8e3s4.ygk()).d5c_1;
    this_4.set(tmp$ret$41);
    return Unit_instance;
  });
  view_5.hbb(p_11, view_11);
  view_2.hbb(p_5, view_5);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_1, view_2);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_0, view_1);
  view.hbb(p_0, view_0);
  if (get_viewIsWide(view)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (Space())(view.pc(), 2.0);
    var tmp0_elvis_lhs_12 = view.ebb_1;
    var p_12 = tmp0_elvis_lhs_12 == null ? view : tmp0_elvis_lhs_12;
    view.gbb(p_12, view_12);
    view.hbb(p_12, view_12);
  }
  var tmp_13 = view.kbb(view.kbb(get_centered(view), view.jbb(AuthDialogSemantic_getInstance())), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(25)));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_13 = view.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
  view.gbb(p_13, view_13);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  view_14.zbm(true);
  Companion_getInstance();
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  var theme_0 = get_appTheme();
  var tmp$ret$66 = new (Set())(theme_0);
  view_14.lba(tmp$ret$66);
  bodyBold(view_14, 'Welcome to Stoze, your escrow solution!');
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (Space())(view_14.pc(), 0.5);
  var tmp0_elvis_lhs_15 = view_14.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
  view_14.gbb(p_15, view_15);
  view_14.hbb(p_15, view_15);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (RowOrCol())(view_14.pc());
  var tmp0_elvis_lhs_16 = view_14.ebb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
  view_14.gbb(p_16, view_16);
  view_16.zbm(true);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (TextView())(view_16.pc());
  var tmp0_elvis_lhs_17 = view_16.ebb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
  view_16.gbb(p_17, view_17);
  view_17.lba(view_17.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_content_$ref_4pzcwl_4(view_17);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb_4(view_17));
  reactiveScope(view_17, ($this$reactiveScope) => {
    var tmp$ret$70 = $this$reactiveScope.daj(_this__u8e3s4.hgl()).v5i_1 + ' is inviting you to protect your project with Stoze.  Deposit funds safely and release payment to your contractor as the project progresses.';
    this_5.set(tmp$ret$70);
    return Unit_instance;
  });
  view_16.hbb(p_17, view_17);
  body(view_16, 'Register now or log in to review scope details before awarding the project.');
  view_14.hbb(p_16, view_16);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (Space())(view_14.pc());
  var tmp0_elvis_lhs_18 = view_14.ebb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_14 : tmp0_elvis_lhs_18;
  view_14.gbb(p_18, view_18);
  view_14.hbb(p_18, view_18);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_19 = new (RowOrCol())(view_14.pc());
  var tmp0_elvis_lhs_19 = view_14.ebb_1;
  var p_19 = tmp0_elvis_lhs_19 == null ? view_14 : tmp0_elvis_lhs_19;
  view_14.gbb(p_19, view_19);
  view_19.zbm(false);
  var tmp_16 = get_expanding(view_19);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_20 = new (Space())(view_19.pc());
  var tmp0_elvis_lhs_20 = view_19.ebb_1;
  var p_20 = tmp0_elvis_lhs_20 == null ? view_19 : tmp0_elvis_lhs_20;
  view_19.gbb(p_20, view_20);
  view_19.hbb(p_20, view_20);
  view_19.lbb(tmp_16, view_20);
  var tmp_17 = get_centered(view_19);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (RowOrCol())(view_19.pc());
  var tmp0_elvis_lhs_21 = view_19.ebb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_19 : tmp0_elvis_lhs_21;
  view_19.gbb(p_21, view_21);
  view_21.zbm(false);
  shownDefaultFalse(view_21, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(_this__u8e3s4.ggi_1));
  view_21.bb9(get_AppDimensions().lg2_1);
  var tmp_18 = get_primaryButton(view_21);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_22 = new (Button())(view_21.pc());
  var tmp0_elvis_lhs_22 = view_21.ebb_1;
  var p_22 = tmp0_elvis_lhs_22 == null ? view_21 : tmp0_elvis_lhs_22;
  view_21.gbb(p_22, view_22);
  specCenteredText(view_22, 'Register');
  view_22.obg(Action('Register', VOID, inviteView$slambda_0(_this__u8e3s4, view_22)));
  view_21.hbb(p_22, view_22);
  view_21.lbb(tmp_18, view_22);
  var tmp_19 = get_secondaryButton(view_21);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_23 = new (Button())(view_21.pc());
  var tmp0_elvis_lhs_23 = view_21.ebb_1;
  var p_23 = tmp0_elvis_lhs_23 == null ? view_21 : tmp0_elvis_lhs_23;
  view_21.gbb(p_23, view_23);
  specCenteredText(view_23, 'Log In');
  view_23.obg(Action('Log In', VOID, inviteView$slambda_2(_this__u8e3s4, view_23)));
  view_21.hbb(p_23, view_23);
  view_21.lbb(tmp_19, view_23);
  view_19.hbb(p_21, view_21);
  view_19.lbb(tmp_17, view_21);
  var tmp_20 = get_expanding(view_19);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_24 = new (Space())(view_19.pc());
  var tmp0_elvis_lhs_24 = view_19.ebb_1;
  var p_24 = tmp0_elvis_lhs_24 == null ? view_19 : tmp0_elvis_lhs_24;
  view_19.gbb(p_24, view_24);
  view_19.hbb(p_24, view_24);
  view_19.lbb(tmp_20, view_24);
  view_14.hbb(p_19, view_19);
  view_13.hbb(p_14, view_14);
  view.hbb(p_13, view_13);
  view.lbb(tmp_13, view_13);
  writer.hbb(p, view);
  return writer.lbb(tmp, view);
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  var tmp = $this.sgz_1.pgm($this.tgz_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var inviteView$slambdaClass;
function inviteView$slambda() {
  if (inviteView$slambdaClass === VOID) {
    class $ {
      constructor($this_inviteView, $$this$button) {
        this.sgz_1 = $this_inviteView;
        this.tgz_1 = $$this$button;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    inviteView$slambdaClass = $;
  }
  return inviteView$slambdaClass;
}
function inviteView$slambda_0($this_inviteView, $$this$button) {
  var i = new (inviteView$slambda())($this_inviteView, $$this$button);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$Action, $completion) {
  var tmp = $this.ugz_1.sgm($this.vgz_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var inviteView$slambdaClass_0;
function inviteView$slambda_1() {
  if (inviteView$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_inviteView, $$this$button) {
        this.ugz_1 = $this_inviteView;
        this.vgz_1 = $$this$button;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    inviteView$slambdaClass_0 = $;
  }
  return inviteView$slambdaClass_0;
}
function inviteView$slambda_2($this_inviteView, $$this$button) {
  var i = new (inviteView$slambda_1())($this_inviteView, $$this$button);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  inviteView as inviteView2x3od30x7hoe5,
};
//endregion

//# sourceMappingURL=inviteView.mjs.map
